exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "strong[data-v-69c516c2]{font-weight:600}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/Home.vue"],"names":[],"mappings":"AACA,wBACE,eAAiB,CAClB","file":"Home.vue","sourcesContent":["\nstrong[data-v-69c516c2] {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69c516c2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/Home.vue
// module id = 1438
// module chunks = 0